var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPolygon = function SvgIconPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 4.5a1.25 1.25 0 1 1 .33.847l-.004-.005-.011-.012A1.25 1.25 0 0 1 10 4.5M8.284 5.83a3.25 3.25 0 1 1 6.213-1.482l2.282.625a3.25 3.25 0 1 1 2.633 5.026l-2.438 6.919a3.25 3.25 0 1 1-5.06 1.561l-6.26-4.595a3.25 3.25 0 1 1-.277-5.449zm7.081 12.474a1 1 0 0 0 .103.037 1.25 1.25 0 1 1-.103-.037m-.277-2.053 2.438-6.919a3.25 3.25 0 0 1-1.273-2.43l-2.281-.625a3.247 3.247 0 0 1-4.348 1.037L6.716 9.92a3.247 3.247 0 0 1 .12 2.351l6.26 4.595a3.24 3.24 0 0 1 1.992-.615m4.049-8.305a1 1 0 0 0-.107-.037 1.25 1.25 0 1 1 .107.037M2.5 11.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconPolygon;